<template>
  <p>Wait a moment, verifying your session...</p>
</template>

<script>
import { Auth } from '@/api';
import Session from '@/helpers/session';
import { mapMutations } from 'vuex';

export default {
  name: 'app-verify',
  methods: {
    ...mapMutations({
      login: 'LOGIN',
    }),
  },
  async mounted() {
    const session = Session();

    try {
      const { data: user } = await Auth.fetch(this.$route.query.token);
      this.login(user);
      session.set(user);
      this.$router.push({ name: 'menu.index' });
    } catch (e) {
      console.log(e);
      this.$router.push({ name: 'login' });
    }
  },
};
</script>
